import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-empty-page',
  templateUrl: './empty-page.page.html',
  styleUrls: ['./empty-page.page.scss']
})
export class EmptyPage {
  @Input() text: string;
  @Input() iconName: string;
  @Input({required: false}) secondIcon: string;

  constructor() { }

}
